import { z } from "zod";
export const CrmLifecycleStageValues = [
    "subscriber",
    "lead",
    "marketing_qualified_lead",
    "sales_qualified_lead",
    "opportunity",
    "customer",
    "evangelist",
    "contact",
    "account",
];
export const CrmMarketingConsentValues = [
    "unknown",
    "opted_in",
    "opted_out",
    "soft_opt_in",
    "legitimate_interest",
];
export const CrmActivityKindValues = [
    "crm.note",
    "crm.call",
    "crm.meeting",
    "email.sent",
    "email.opened",
    "email.clicked",
    "email.opted_out",
    "email.bounced",
    "email.inbound",
    "email.outbound",
    "deal.created",
    "deal.stage_changed",
    "deal.closed_won",
    "deal.closed_lost",
    "deal.next_action_updated",
    "booking.scheduled",
    "project.created",
    "project.updated",
    "task.created",
    "task.completed",
    "document.created",
    "document.viewed",
    "signature.sent",
    "signature.completed",
    "contact.enquiry",
];
export const CrmActivitySourceSystemValues = [
    "crm",
    "email",
    "scheduling",
    "projects",
    "documents",
    "signatures",
    "system",
    "website",
];
export const CrmActivityVisibilityValues = ["staff", "board", "private"];
export const CrmLifecycleStageSchema = z.enum(CrmLifecycleStageValues);
export const CrmMarketingConsentSchema = z.enum(CrmMarketingConsentValues);
export const CrmActivityKindSchema = z.enum(CrmActivityKindValues);
export const CrmActivitySourceSystemSchema = z.enum(CrmActivitySourceSystemValues);
export const CrmActivityVisibilitySchema = z.enum(CrmActivityVisibilityValues);
export const CrmActivityEventSchema = z.object({
    id: z.string().uuid(),
    kind: CrmActivityKindSchema,
    title: z.string().min(1).max(240),
    summary: z.string().nullable().default(null),
    occurredAt: z.string().datetime(),
    actorEmail: z.string().email().nullable().default(null),
    contactId: z.string().uuid().nullable().default(null),
    companyId: z.string().uuid().nullable().default(null),
    dealId: z.string().uuid().nullable().default(null),
    trackedEmailId: z.string().uuid().nullable().default(null),
    emailTrackingEventId: z.string().uuid().nullable().default(null),
    projectId: z.string().uuid().nullable().default(null),
    taskId: z.string().uuid().nullable().default(null),
    documentId: z.string().uuid().nullable().default(null),
    signatureRequestId: z.string().uuid().nullable().default(null),
    bookingId: z.string().uuid().nullable().default(null),
    sourceSystem: CrmActivitySourceSystemSchema.default("crm"),
    payload: z.record(z.string(), z.unknown()).default({}),
    visibility: CrmActivityVisibilitySchema.default("staff"),
    dedupeKey: z.string().max(200).nullable().default(null),
    createdAt: z.string().datetime(),
});
export const CrmActivityListQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(100).default(50),
    offset: z.coerce.number().int().min(0).default(0),
    kind: CrmActivityKindSchema.optional(),
});
export const CrmActivityListResponseSchema = z.object({
    events: z.array(CrmActivityEventSchema),
    total: z.number().int(),
    hasMore: z.boolean(),
});
//# sourceMappingURL=crm-activity.js.map